import { observer } from 'mobx-react';
import { Space, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { Routes } from '../../../../../../route/Routes';
import { InteractiveText } from '../../../../../../component/InteractiveText';
import {
  RaffleStore,
  RaffleStoreProvider,
  useRaffleStore,
} from '../../RaffleStore';
import { RafflePreview } from '../raffle-preview';
import { useMemo } from 'react';
import { EmptyEvents } from '../../../news';

const RaffleSectionContent = observer(() => {
  const { t } = useTranslation('homescreen');
  const store = useRaffleStore();

  const hasRaffles =
    store.activeRaffles.length > 0 ||
    store.upcomingRaffles.length > 0 ||
    store.pastRaffles.length > 0;

  const isLoadingPreview = store.isLoadingActive || store.isLoadingFuture;
  const showEmpty = !isLoadingPreview && !hasRaffles;

  return (
    <>
      <Space />
      <div>
        <Text fw="600" size="21px" lh="24px">
          {t('ContestAndEvents.Title')}
        </Text>
        <Text size="16px" lh="24px" my="5px">
          {t('ContestAndEvents.Description')}
        </Text>
        <Space h="13px" />
        {showEmpty ? <EmptyEvents /> : <RafflePreview />}
        {hasRaffles && (
          <>
            <Space h="16px" />
            <InteractiveText
              text={t('ShowAll')}
              navigateTo={`${Routes.Study}/${Routes.Raffles}`}
            />
          </>
        )}
      </div>
    </>
  );
});

export const RaffleSection = () => {
  const store = useMemo(() => new RaffleStore(), []);

  return (
    <RaffleStoreProvider store={store}>
      <RaffleSectionContent />
    </RaffleStoreProvider>
  );
};
